//#region
import axios from 'axios'
import { url, endPoint } from '../urls'
//#endregion

export const addVersion = (params) => {
  let _url = url.backendHost + endPoint.config.addVersion
  return axios.post(_url, params)
}

export const getSignature = (params) => {
  let _url = `${url.backendHost}/generateSignature`
  return axios.post(_url, params)
}

export const updateConfig = (params) => {
   let _url = url.backendHost + endPoint.config.updateConfig
  return axios.put(_url, params)
}

export function getConfig(params) {
    let _url = url.backendHost + endPoint.config.getConfig;
    return axios.get(_url, { params });
}

